module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d667efad2534ade6f4b440ed816ff039.png";